import { TestIdClassNameProps } from "@app/types/Common";
import { BlockTitle } from "@blocks/Blocks";
import SeeMore from "@components/SeeMore/SeeMore";
import useLatestVideos from "@hooks/useLatestVideos";
import { sectionNavigationItems } from "@util/constant";

import VideosStories from "./VideoStories";

const section = sectionNavigationItems.videos;

export default function Video({
  testId,
  rootClassName,
}: TestIdClassNameProps): React.ReactElement {
  const videos = useLatestVideos();

  return (
    <section className={rootClassName} data-testid={testId}>
      <BlockTitle link={section?.link} text={section?.label?.toUpperCase()} />

      <div className="videos">
        {videos?.map((video, index) => {
          return (
            <VideosStories key={video.video_id} index={index} {...video} />
          );
        })}
      </div>

      <SeeMore rootClassName="mt-4" text="SEE MORE" link={section?.link} />
    </section>
  );
}
